module.exports = "<svg height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32.63 32.63\"><path d=\"M32.13 16.82H.5c-.28 0-.5-.23-.5-.5s.22-.5.5-.5h31.64c.27 0 .5.22.5.5s-.23.5-.5.5z\"/><path d=\"M19.6 29.35c-.13 0-.26-.05-.36-.14-.2-.2-.2-.5 0-.7l12.2-12.18-12.2-12.18c-.2-.2-.2-.52 0-.7s.52-.2.7 0L32.5 15.95c.08.1.13.22.13.36s-.05.26-.14.35L19.94 29.2c-.1.1-.22.15-.35.15z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-right.svg
// module id = ./src/icons/arrow-right.svg
// module chunks = 21